import React, {useEffect} from 'react'
import {ReactComponent as SearchIcon} from '../../../../media/white_search_icon.svg'
import {useDispatch, useSelector} from 'react-redux'
import {bindActionCreators} from 'redux'
import {actionsGUListarUsuarios} from '../../../../actions/action-creators'
import {State} from '../../../../reducers'

const LIFromFiltros = () => {
  const form = useSelector((state: State) => state.gestionUsuario.listarUsuarios.formBuscar)
  const arrayUsuarios = useSelector(
    (state: State) => state.gestionUsuario.listarUsuarios.arrayUsuarios
  )
  const dispatch = useDispatch()
  const acciones = bindActionCreators(actionsGUListarUsuarios, dispatch)

  useEffect(() => {
    if (
      !form.username &&
      !form.first_name &&
      !form.second_name &&
      !form.last_name &&
      !form.last_name2 &&
      !form.id_number &&
      arrayUsuarios.length > 0
    )
      acciones.gu_lu_BuscarUsuario(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form])

  const buscar = (e: any) => {
    e.preventDefault()
    acciones.gu_lu_BuscarUsuario()
  }

  return (
    <form onSubmit={buscar} >
      <div className='listar-usuario-form-filter'>
        <div className='filter-field'>
          <label htmlFor='username' className='field-label m'>
            Nombre de usuario
          </label>
          <input autoComplete='off'
            type='text'
            className='m text-field normal w-input'
            autoFocus={true}
            maxLength={75}
            data-name='username'
            name='username'
            placeholder='Nombre de usuario'
            onChange={acciones.gu_lu_FormBuscarHandleChange}
            value={form.username}
          />
        </div>
        <div className='filter-field'>
          <label htmlFor='first_name' className='field-label m'>
            Primer nombre
          </label>
          <input autoComplete='off'
            type='text'
            className='m text-field normal w-input'
            maxLength={100}
            data-name='first_name'
            name='first_name'
            placeholder='Primer nombre'
            onChange={acciones.gu_lu_FormBuscarHandleChange}
            value={form.first_name}
          />
        </div>
        <div className='filter-field'>
          <label htmlFor='second_name' className='field-label m'>
            Segundo nombre
          </label>
          <input autoComplete='off'
            type='text'
            className='m text-field normal w-input'
            maxLength={100}
            data-name='second_name'
            name='second_name'
            placeholder='Segundo nombre'
            onChange={acciones.gu_lu_FormBuscarHandleChange}
            value={form.second_name}
          />
        </div>
        <div className='filter-field'>
          <label htmlFor='last_name' className='field-label m'>
            Primer apellido
          </label>
          <input autoComplete='off'
            type='text'
            className='m text-field normal w-input'
            maxLength={100}
            data-name='last_name'
            name='last_name'
            placeholder='Primer apellido'
            onChange={acciones.gu_lu_FormBuscarHandleChange}
            value={form.last_name}
          />
        </div>
        <div className='filter-field'>
          <label htmlFor='last_name2' className='field-label m'>
            Segundo apellido
          </label>
          <input autoComplete='off'
            type='text'
            className='m text-field normal w-input'
            maxLength={100}
            data-name='last_name2'
            name='last_name2'
            placeholder='Segundo apellido'
            onChange={acciones.gu_lu_FormBuscarHandleChange}
            value={form.last_name2}
          />
        </div>
        <div className='filter-field'>
          <label htmlFor='id_number' className='field-label m'>
            No. documento
          </label>
          <input autoComplete='off'
            type='text'
            className='m text-field normal w-input'
            maxLength={45}
            data-name='id_number'
            name='id_number'
            placeholder='No. Identificación'
            onChange={acciones.gu_lu_FormBuscarHandleChange}
            value={form.id_number}
          />
        </div>
        <div>
          <button type='submit' className='icon-button filter-search-btn'>
            <SearchIcon width={20} height={20} />
          </button>
        </div>
      </div>
    </form>
  )
}

export default LIFromFiltros
